import { apiStoreLenses } from 'root/src/client/logic/api/lenses'
import currentRouteParamsRecordId from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'

const { viewDropEventChild } = apiStoreLenses

export default (state, { recordId } = {}) => {
	const recordIdMod = currentRouteParamsRecordId(state) || recordId
	return viewDropEventChild(recordIdMod, state)
}
